import React from 'react';
import Cookies from 'js-cookie';
import { Navigate, Outlet } from 'react-router-dom';

const adminUuid = 'adminUuid';
const adminRoles = 'adminRoles';
const accessToken = 'accessToken';

const whitelist = [
  '53b291b8-a471-4afa-8d25-a433a44dcb08',
  '0a785187-ff97-427a-8299-0583554a4a64',
  'a759a987-4c48-4d82-973d-89be5fe7a56d',
];

export const removeCookies = () => {
  removeAccessToken();
  removeAdminRoles();
  removeAdminUuid();
};

export const setAccessToken = (token: string) =>
  Cookies.set(accessToken, token);

export const removeAccessToken = () => Cookies.remove(accessToken);

export const getAccessToken = () => Cookies.get(accessToken);

export const isAuthenticated = () => !!getAccessToken();

export const setAdminUuid = (uuid: string) => Cookies.set(adminUuid, uuid);

export const removeAdminUuid = () => Cookies.remove(adminUuid);

export const getAdminUuid = () => Cookies.get(adminUuid) || '';

export const setAdminRoles = (roles: string[]) =>
  Cookies.set(adminRoles, JSON.stringify(roles));

export const removeAdminRoles = () => Cookies.remove(adminRoles);

export const getAdminRoles = () => JSON.parse(Cookies.get(adminRoles) || '[]');

export const isSuperUser = () => whitelist.includes(getAdminUuid());

export const isSystemAdmin = () =>
  isSuperUser() || getAdminRoles().includes('system');

/**
 * A component to protect routes in React Router.
 * If a valid token exists, it renders the component.
 * Otherwise, it redirects to the login page.
 */
export const ProtectedRoute = () => {
  if (isAuthenticated()) return <Outlet />;

  return <Navigate to="/login" replace />;
};
